import { StudentVerificationDetailsProps } from "./studentCertificate.model";
import { Checkbox, Typography } from "antd";

const { Paragraph } = Typography;

export const StudentVerificationDetails = ({
  student_full_name,
  course,
  email,
  branch_name,
  termsAccepted,
  onCheckboxChange,
}: StudentVerificationDetailsProps) => {
  const branchName = branch_name
    ? branch_name.toUpperCase().replace(/\s+/g, " ")
    : "";

  const hasDash = branchName.includes("-");
  const trainingCenter = hasDash
    ? branchName.split("-").pop()?.trim()
    : "";

  const fullBranchName = `RED & WHITE SKILL EDUCATION${hasDash ? " - " + trainingCenter : ""}`;

  const studentDetails = [
    { label: "Student Name", value: student_full_name },
    { label: "Course Name", value: course },
    { label: "Student Email ID", value: email },
    { label: "Branch Name", value: fullBranchName },
  ];

  return (
    <div>
      {studentDetails.map((item, index) => (
        <p key={index}>
          <span className="label-text">{item.label}: </span> {item.value}
        </p>
      ))}

      <div className="reasons-box">
        <Paragraph className="warning-text">
          Important: Verify all details above before applying, as they'll be
          printed on your certificate. No changes can be made after generation.
          Visit your branch to correct any errors first.
        </Paragraph>

        <div className="terms-container">
          <span className="label-text">T&C:</span>
          <div className="terms-scrollable">
            <ul className="terms-list">
              <li>
                Certificates will be issued only once upon successful completion
                of the course.
              </li>
              <li>
                Students are advised to store the certificate securely. In case
                of loss, damage, or request for a duplicate certificate, a
                reissue will be chargeable.
              </li>
              <li>
                The reissued certificate may take additional processing time.
              </li>
              <li>
                Students must carefully verify the spelling and accuracy of
                their name and personal details before final submission.
              </li>
              <li>
                Once the data is submitted, no further edits will be allowed
                without an additional charge.
              </li>
              <li>
                The name provided in the professional document will appear on
                the certificate.
              </li>
            </ul>
          </div>
        </div>
      </div>

      <Checkbox
        className="custom-red-checkbox"
        checked={termsAccepted}
        onChange={onCheckboxChange}
      >
        I have verified all details and accept the terms and conditions.
      </Checkbox>
    </div>
  );
};
